export default __webpack_public_path__ + "static/media/thief.88aa7ca7.png";